import  {  useState } from "react";

import { Row } from '@shadcn/components/ui/row'
import { Col } from '@shadcn/components/ui/col'
import { Card, CardContent as CardBody} from '@shadcn/components/ui/card'
import { Button } from "@shadcn/components/ui/button";
import useQuery from '../../../helpers/JIFI/useQuery';
import { backendUrl } from "../../../helpers/consts";
import superagent from 'superagent'
import { toast } from 'react-toastify';

const HistoricStockLevels = () => {
  const [refresh, setRefresh] = useState(true)
  const refreshData = () => {
      setRefresh(prev => !prev)
  }

  const [csvList, csvListState] = useQuery({
    url: `/inventory/listFiles`,
    refresh,
  });

  const handleDownload = async (fileKey) => {
    try {
      const response = await superagent
        .get(`${backendUrl}/inventory/getFile`)
        .query({ key: fileKey })
        .set('Authorization', `Bearer ${localStorage.getItem("authJWT")}`)
        .responseType('blob'); // superagent returns the Blob on response.body

      const blobUrl = window.URL.createObjectURL(response.body);

      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = fileKey.replace('stocklevel-history/', ''); // clean YYYY-MM-DD.csv filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      toast.error(err?.response?.body?.message ?? err?.message ?? 'Download failed');
    }
  };

  const user = JSON.parse(localStorage.getItem("authUser"));

  return <>
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col md={12}>
            <Card className='mb-6'>
              <div style={{margin: '0 12px'}}>
                <h4 className="card-title my-6">History Stock Levels</h4>
              </div>
              <CardBody>
                <div style={{
                  display: 'block',
                  width: '100%',
                  whiteSpace: 'nowrap'
                }}>
                {
                  csvList ? (
                    <table className="table mb-0">
                        <thead style={{position: 'sticky', top: 0, background: 'white', }}>
                            <tr>
                                <th>Date</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                          {
                            csvList.map(line => {
                              return (
                                <tr>
                                  <td>{line.Key.replace('stocklevel-history/', '')}</td>
                                  <td> <Button onClick={() => handleDownload(line.Key)}> Download </Button> </td>
                                </tr>
                              )
                            })
                          }
                        </tbody>
                    </table>
                  ) : (
                    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                      <div className="spinner-border text-primary m-1" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  )
                }
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  </>
}

export default HistoricStockLevels
